var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMusd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 3.393c.105 1.146.175 2.256.175 3.4v14.372h5.188v-10.32c0-1.224 0-4.088 3.239-4.088 2.855 0 2.89 2.577 2.89 3.973v10.435h5.19V12.42c0-2.685.069-5.655 3.169-5.655 2.682 0 2.96 2.147 2.96 4.08v10.32h5.186V10.972c.004-1.545.01-3.559-.874-5.037-.382-.715-1.81-2.9-5.361-2.9-1.812 0-4.187.466-5.642 3.365-.342-.857-1.49-3.4-5.53-3.4C9.074 3 7.72 4.926 7.163 5.717l-.003.004-.172-2.327H2zm28 21.748H2v4.4h28v-4.4z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusd);
export default __webpack_public_path__ + "static/media/MUSD.b97b0e9461a18a583eb45d9ee55a791d.svg";
export { ForwardRef as ReactComponent };